const ProjectList = {
  Software: [
    {
      name: "UIU Robotics",
      image: "/assets/uiu_robotics.png",
      github: "https://github.com/aranya170/UIURC.git",
      website: "https://robotics.uiu.ac.bd/",
      tags: ["Tailwind CSS", "Laravel", "UI/UX Design", "PHP"],
      files: [
        {
          name: "UIU Robotics Website",
          type: "notebook",
          content: "https://robotics.uiu.ac.bd/",
          language: "robotics.uiu.ac.bd",
        },
        {
          name: "README.md",
          type: "info",
          content:
            "Initiated, designed, and implemented the official full-stack website for UIU Robotics. I handled the entire lifecycle from initial prototyping to final deployment. The platform serves as a central hub for club members, showcasing robotics projects, managing events, and fostering innovation within the university community.",
        },
      ],
    },
    {
      name: "Dacca Delights",
      image: "/assets/daccadelights.png",
      github: "https://github.com/aranya170/DaccaDelights.git",
      website: "https://daccadelights.com/",
      tags: ["MySQL", "Tailwind CSS", "PHP"],
      files: [
        {
          name: "Dacca Delights Website",
          type: "notebook",
          content: "https://daccadelights.com/",
          language: "daccadelights.com",
        },
        {
          name: "README.md",
          type: "info",
          content:
            "A full-stack e-commerce platform developed for a bakery shop. This freelance project involved designing an intuitive frontend and a robust backend to manage orders, inventory, and customer interactions. Hosted at daccadelights.com, the site provides a seamless shopping experience for high-quality baked goods.",
        },
      ],
    },
    {
      name: "DirectEdge",
      image: "/assets/directedge.png",
      github: "https://github.com/aranya170/DirectEdge",
      tags: [
        "Computer Vision",
        "Deep Learning",
        "Python",
        "Tailwind CSS",
        "React",
      ],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "DirectEdge revolutionizes sourcing by connecting businesses directly with farmers, streamlining distribution for fresher, sustainable goods. As an all-in-one solution, we manage procurement through delivery via a transparent supply chain. We’ve integrated a compact, user-friendly POS and ERP system alongside advanced demand forecasting to optimize efficiency. By eliminating intermediaries, we ensure competitive pricing for businesses and fair compensation for farmers. Join us in building a smarter, data-driven, and sustainable food system.",
        },
      ],
    },
    {
      name: "Kairos",
      image: "/assets/kairos.png",
      github: "https://github.com/aranya170/Kairos",
      tags: ["MySQL", "Bootstrap", "PHP", "JavaScript"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "Kairos functions as a supportive system meticulously crafted to facilitate personal growth and development. Our primary objective revolves around fostering the cultivation of positive habits, furnishing users with effective tools for life tracking, and aiding in the eradication of detrimental behaviors, notably procrastination.",
        },
      ],
    },
    {
      name: "Peer Pie",
      image: "/assets/peerpie.png",
      github: "https://github.com/aranya170/Peer_Pie/tree/main",
      tags: ["JAVA", "MySQL", "CSS"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "Connecting learners, expanding horizons. Peer Pie is a platform designed to connect students with peers who share similar interests, enabling them to collaborate on projects, share knowledge, and learn from each other. The platform aims to foster a community of learners who can support and motivate one another in their academic journeys.",
        },
      ],
    },
  ],
  Research: [
    {
      name: "RoboNeT - Robotics, Networking, IoT & Data Communication Repository",
      image: "/assets/research.png",
      github: "https://github.com/FahimHafiz/RoboNeT-Robotics-Network-IoT-Repository.git",
      tags: ["Autonomus", "Robotics", "IoT", "Data Communication"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "I led the development of RoboNeT as its highest contributor and Undergraduate Assistant of United International University, establishing Bangladesh’s first-ever open-source repository dedicated to robotics learning. This comprehensive platform centralizes resources for robotics, networking, IoT, and data communication to empower the country's next generation of engineers and researchers.",
        },
        {
          name: "RoboNeT-Robotics-Network-IoT-Repository",
          type: "notebook",
          content: "https://prettyhub.vercel.app/FahimHafiz/RoboNeT-Robotics-Network-IoT-Repository",
          language: "Robotics, Networking, IoT & Data Communication",
        },
      ],
    },
    {
      name: "Identification and Classification of the Dark Triad Personality Traits Using Machine Learning",
      image: "/assets/DarkTriads.png",
      tags: ["Pandas", "Numpy", "Matplotlib"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "This project utilizes machine learning algorithms to analyze behavioral data and psychometric patterns for the automated detection of Machiavellianism, Narcissism, and Psychopathy. By identifying these 'Dark Triad' traits, the system provides a data-driven framework for personality classification in clinical, organizational, or forensic contexts.",
        },
        {
          name: "FinalUpdate.ipynb",
          type: "notebook",
          content: "https://nbviewer.org/github/aranya170/Dark-Traid-Personality/blob/main/FinalUpdate.ipynb",
          language: "python",
        },
      ],
    },
    {
      name: "Adaptive Weighted Ensemble Learning for Mixed Waste Classification",
      image: "/assets/research2.jpg",
      tags: ["Pandas", "Latex", "Matplotlib"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "This project implements an adaptive ensemble framework that dynamically adjusts the influence of multiple deep learning models to improve classification accuracy across diverse waste streams. By prioritizing the most reliable sub-models for specific materials, the system achieves superior robustness in identifying recyclables and hazardous items within complex, mixed environments.",
        },
      ],
    },
  ],
  Hardware: [
    {
      name: "Delta Arm",
      image: "/assets/Hardware5.jpg",
      tags: ["Arduino", "Inverse Kinematics", "Parallel Robotics", "3D Printing"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "Developed a high-speed Delta parallel robot designed for rapid assembly and precision sorting. Utilizing a parallel kinematic geometry, I synchronized three motors to control spatial coordinates via complex inverse kinematics. This design ensures the end-effector remains stable and parallel to the work surface, enabling high-acceleration movements and exceptional repeatability.",
        },
      ],
    },
    {
      name: "Scara Arm",
      image: "/assets/Hardware4.jpeg",
      tags: ["Arduino Nano", "3D Design", "Kinematics"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "Designed and prototyped a 4-axis SCARA robotic arm utilizing 3D-printed components and an Arduino Nano. The project focuses on high-precision movement for automated pick-and-place tasks. I implemented the kinematics logic to control joint rotations, ensuring smooth trajectories while optimizing the arm’s reach and payload stability.",
        },
      ],
    },
    {
      name: "4 Wings Drone",
      image: "/assets/Hardware3.jpg",
      tags: ["Arduino Nano", "3D Design", "Brushless Motor"],
      files: [
        {
          name: "README.md",
          type: "info",
          content: "Built a 4-wings quadcopter drone powered by brushless motors and Arduino-based flight stabilization.",
        },
      ],
    },
    {
      name: "IOT Based Smart Bus Tracking System",
      image: "/assets/Hardware1.png",
      github: "https://github.com/aranya170/Shuttle-Bus-Tracking-System",
      tags: ["Arduino", "ESP 32", "LDR", "GPS Module"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "This project is a comprehensive Shuttle Bus Tracking and Monitoring System developed for a university-level IoT and embedded systems project. The system combines multiple sensors and technologies to ensure real-time location tracking, passenger queue monitoring, environmental sensing, and safety alerts for shuttle operations on campus.",
        },
      ],
    },
    {
      name: "Smart Voting Machine",
      image: "/assets/Hardware2.jpg",
      tags: ["Arduino", "i2C", "Buzzer", "Laser"],
      files: [
        {
          name: "README.md",
          type: "info",
          content:
            "Designed and fabricated an IoT-enabled smart voting machine ensuring biometric authentication, tamper-evident vote logging, and real-time tabulation using embedded microcontrollers.",
        },
      ],
    },
  ],
};

export default ProjectList;
